import cn from 'classnames';
import React from 'react';

import { Avatar, Rate, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import pluralize from '@sravni/utils/lib/pluralize';

import styles from './logobox.module.scss';

export interface ILogoItem {
  name: string;
  imgUrl: string;
  itemUrl: string;
  rating: number;
  reviewsCount: number;
}

interface ILogoProps {
  className?: string;
  item: ILogoItem;
  isBank: boolean;
  isSecondLine?: boolean;
}

export const Logo: React.FC<ILogoProps> = React.memo(({ className, item, isSecondLine }) => {
  const isMobile = useIsMobile();

  return (
    <a href={item.itemUrl} className={cn(className, styles.item, isSecondLine && styles['item--second-line'])}>
      <Avatar src={item.imgUrl} size={44} />
      <div className={styles.item__info}>
        <Typography.Heading level={isMobile ? 5 : 6}>{item.name}</Typography.Heading>

        <Space align={'center'}>
          <Rate count={1} value={1} disabled className={styles.starIcon} />
          <Typography.Text size={14} className={styles.item__rating}>
            {item.rating.toFixed(1).replace('.', ',')}
          </Typography.Text>

          <Typography.Text size={12} className={cn('h-color-D30', styles.item__reviewsCount)}>
            {item.reviewsCount} {pluralize(item.reviewsCount, 'отзыв', 'отзыва', 'отзывов')}
          </Typography.Text>
        </Space>
      </div>
    </a>
  );
});
